define([
    "./transitionsModule",
    "text!./nlgTransitionTimelineTooltip.html"
], function (transitionsModule, transitionTooltipTemplate) {
    "use strict";

    return transitionsModule.run(["$templateCache", function ($templateCache) {
        $templateCache.put("nlgTransitionTimelineTooltip.html", transitionTooltipTemplate)
    }])
});